import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Button from 'src/components/Button';
import permissions from 'src/constants/permissions';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import { deleteBankAPI } from 'src/serverApi/banks';
import Modal from 'src/components/Modal';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

type Props = {
  organizationUeid: string;
  organizationName: string;
  bankUeid: string;
  bankName: string;
  handleBanksChange: () => void;
};

const DeleteBankLink: React.FC<Props> = ({
  organizationUeid,
  organizationName,
  bankUeid,
  bankName,
  handleBanksChange,
}) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const withDataManagementAuthorities = useWithAuthorities([permissions.dataManagement]);

  const handleLinkClick = (e: any) => {
    e.preventDefault();
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleDeleteAccept = async () => {
    try {
      setIsLoading(true);
      await withDataManagementAuthorities(async () => {
        await deleteBankAPI(organizationUeid, bankUeid);
        handleBanksChange();
        toast.success('Банк удалён');
        setDialogOpen(false);
      });
    } catch (error) {
      toast.error('При попытке удалить банк произошла ошибка');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <a href="#" onClick={handleLinkClick}>
        Удалить
      </a>
      <Modal
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Удаление банка"
        content={
          <Text type="p" muted>
            Вы действительно хотите удалить банк "{bankName}" для организации "{organizationName}
            "? При этом управление списком ТСП и получение токенов для этой организации и банка
            станет недоступно.
          </Text>
        }
        footer={
          <>
            <Button disabled={isLoading} onClick={handleCloseDialog} className={styles['modal-button']}>
              Отмена
            </Button>
            <Button
              variant="outlined"
              disabled={isLoading}
              onClick={handleDeleteAccept}
              className={styles['modal-button']}
            >
              Удалить
            </Button>
          </>
        }
      />
    </>
  );
};

export default DeleteBankLink;
